module.exports = __webpack_public_path__ + "static/media/Bumppy Payments4.34c9e606.png";